import {
  Component,
  ElementRef,
  inject,
  OnDestroy,
  OnInit,
} from '@angular/core';

import { combineLatest, Subscription } from 'rxjs';
import { filter, tap } from 'rxjs/operators';

import {
  layoutCoreSplashscreenAnimation,
  layoutCoreSplashscreenLogoAnimation,
} from '@lib-core/layout/animations/layout-core-splashscreen.animation';

import { ScreenModeEnum } from '@lib-shared/screen/models/screen-mode.enum';

import { ScreenHelperService } from '@lib-shared/screen/services/screen-helper.service';
import { LayoutCoreSplashscreenService } from '../../services/layout-core-splashscreen.service';
import { NgClass, AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-layout-core-splashscreen',
  templateUrl: './layout-core-splashscreen.component.html',
  styleUrls: ['./layout-core-splashscreen.component.scss'],
  animations: [
    layoutCoreSplashscreenAnimation,
    layoutCoreSplashscreenLogoAnimation,
  ],
  standalone: true,
  imports: [NgClass, AsyncPipe],
})
export class LayoutCoreSplashScreenComponent implements OnInit, OnDestroy {
  animation: string;

  private subscriptions: Subscription = new Subscription();
  private readonly ref: ElementRef = inject(ElementRef);

  /**
   * constructor
   *
   */
  constructor(
    public layoutSplashscreenService: LayoutCoreSplashscreenService,
    private screenHelperService: ScreenHelperService,
  ) {}

  /**
   * ngOnInit
   *
   */
  ngOnInit(): void {
    this.subscriptions.add(
      combineLatest([
        this.layoutSplashscreenService.isAnimationActive$,
        this.screenHelperService.screenMode$,
      ])
        .pipe(
          filter(([isActive]) => isActive),
          tap(([isActive, screenMode]) => {
            this.animation =
              screenMode === ScreenModeEnum.Desktop
                ? 'splashscreenCloseDesktop'
                : 'splashscreenCloseMobile';
          }),
        )
        .subscribe(),
    );

    const splashscreenParams = new URLSearchParams(window.location.search).get(
      'splashscreen',
    );

    if (splashscreenParams === 'false') {
      this.ref.nativeElement.style.setProperty('display', 'none');
    }
  }

  /**
   * ngOnDestroy
   *
   */
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  /**
   * onAnimationComplete
   *
   */
  onAnimationComplete(event: any): void {
    if (event.totalTime > 0) {
      this.layoutSplashscreenService.isAnimationActive$.next(false);
      this.layoutSplashscreenService.isAnimationCompleted$.next(true);
    }
  }
}
